import React, { useState, useEffect, useCallback, useMemo } from 'react'
import ElementEditor from './ElementEditor'
import PanelHeader from '~/Common-Objects/TemplateEditor/PanelHeader'
import i18n from '~/i18n'

export default function DragDropRightTools(props) {
    const [isDragging, setIsDragging] = useState(false)
    const [holderWidth, setHolderWidth] = useState(550)

    const dragStart = useCallback((event) => {
        if (event.target.id == 'moveBar') {
            setIsDragging(true)
        }
    }, [])

    const dragEnd = useCallback(() => {
        setIsDragging(false)
    }, [])

    const dragging = useCallback((event) => {
        setIsDragging((prevIsDragging) => {
            if (prevIsDragging) {
                event.preventDefault()
                var currX = document.body.clientWidth - event.clientX
                if (currX < 495) currX = 495
                setHolderWidth(currX)
            }
            return prevIsDragging
        })
    }, [])

    useEffect(() => {
        document.addEventListener('mousedown', dragStart, false)
        document.addEventListener('mouseup', dragEnd, false)
        document.addEventListener('mousemove', dragging, false)

        return () => {
            document.removeEventListener('mousedown', dragStart, false)
            document.removeEventListener('mouseup', dragEnd, false)
            document.removeEventListener('mousemove', dragging, false)
        }
    }, [dragStart, dragEnd, dragging])

    const classes = useMemo(() => {
        let classNames = ''
        if (props.selectedElement.isSelected === true) {
            classNames += ' expanded'
        }
        return classNames
    }, [props.selectedElement.isSelected])

    const style = useMemo(() => {
        let styleObj = {}

        if (isDragging) {
            styleObj.transition = 'none'
        }

        if (props.selectedElement.isSelected === true) {
            styleObj.flex = '0 1 ' + holderWidth + 'px'
        }

        if (props.marketOpen) {
            styleObj.width = '0px'
            styleObj.flex = '0 0 0%'
            styleObj.overflow = 'hidden'
        }

        return styleObj
    }, [isDragging, holderWidth, props.selectedElement.isSelected, props.marketOpen, props.templateType])

    return (
        <div className={classes} style={style}>
            {props.selectedElement.isSelected === true && (
                <div style={{ height: '100%', position: 'relative' }}>
                    <div className='dd_elementEditorOuter'>
                        <ElementEditor
                            landingPage={props.landingPage}
                            isForm={props.isForm}
                            isLandingPage={props.isLandingPage}
                            landingPageId={props.landingPageId}
                            campaign={props.campaign}
                            selectedElement={props.selectedElement}
                            elementsData={props.templateJson}
                            deselectElement={props.deselectElement}
                            updateElementsData={props.updateElementsData}
                            templateId={props.templateId}
                            saveFaveColor={props.saveFaveColor}
                            isDragging={props.isDragging}
                            expandedElements={props.expandedElements}
                            setExpandedElements={props.setExpandedElements}
                            saveTemplate={props.saveTemplate}
                            openGlobalStyle={props.openGlobalStyle}
                            globalStyleFocus={props.globalStyleFocus}
                            canvasScreenType={props.canvasScreenType}
                        />
                    </div>
                </div>
            )}
            {props.selectedElement.isSelected === false && (
                <div style={{ height: '100%' }}>
                    <PanelHeader
                        title={i18n.t('templates:add.drag.style.header')}
                        subtitle={
                            props.templateType === 'landingPage'
                                ? i18n.t('templates:add.drag.style.subHeaderLanding')
                                : props.templateType === 'form'
                                  ? i18n.t('templates:add.drag.style.subHeaderForm')
                                  : i18n.t('templates:add.drag.style.subHeaderEmail')
                        }
                        hideBorder={true}
                    />
                    <ElementEditor
                        formLandingPage={props.formLandingPage}
                        isFormLandingPage={props.isFormLandingPage}
                        isForm={props.isForm}
                        isLandingPage={props.isLandingPage}
                        landingPageId={props.landingPageId}
                        campaign={props.campaign}
                        selectedElement={props.selectedElement}
                        elementsData={props.templateJson}
                        deselectElement={props.deselectElement}
                        updateElementsData={props.updateElementsData}
                        templateId={props.templateId}
                        noTitleBar={true}
                        expandedElements={props.expandedElements}
                        setExpandedElements={props.setExpandedElements}
                        openGlobalStyle={props.openGlobalStyle}
                        globalStyleFocus={props.globalStyleFocus}
                        canvasScreenType={props.canvasScreenType}
                    />
                </div>
            )}
        </div>
    )
}
